var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('path',{style:(("fill:" + _vm.fillColor)),attrs:{"d":_vm.pathData}})])}
var staticRenderFns = []

export { render, staticRenderFns }